import { CODInput } from "../../ui/CODinput";
import { Select } from "../../ui/Select";

const buttonStyles = {
  save: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    background: "#07b1b0",
    color: "#fff",
    cursor: "pointer",
  },
  cancel: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
  },
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
  marginTop: "10px",
};

const AddSubscriptionForm = ({ formData, onChange, onSubmit, onCancel }) => {
  return (
    <form>
      <CODInput
        label="Plan Name"
        type="text"
        name="planName"
        value={formData.planName}
        onChange={onChange}
        required
      />
      <CODInput
        label="Open Request Limit"
        type="number"
        name="openRequestLimit"
        value={formData.openRequestLimit}
        onChange={onChange}
        required
      />
      <CODInput
        label="Create Request"
        type="number"
        name="createRequest"
        value={formData.createRequest}
        onChange={onChange}
        required
      />
      <CODInput
        label="Finalize Request"
        type="number"
        name="finalizeRequest"
        value={formData.finalizeRequest}
        onChange={onChange}
        required
      />
      <CODInput
        label="COnD Communication"
        type="number"
        name="codCommunication"
        value={formData.codCommunication}
        onChange={onChange}
        required
      />
      <CODInput
        label="Data Provider Call"
        type="number"
        name="dataProviderCall"
        value={formData.dataProviderCall}
        onChange={onChange}
        required
      />

      <CODInput
        label="AI Search Limit (per month)"
        type="number"
        name="aiSearchLimit"
        value={formData.aiSearchLimit}
        onChange={onChange}
        placeholder="100"
      />

        <CODInput
        label="Active User Allowed"
        type="number"
        name="AllowedActiveUser"
        value={formData.AllowedActiveUser}
        onChange={onChange}
        required
      />
    

      <div style={buttonContainerStyle}>
        <button type="submit" style={buttonStyles.save} onClick={onSubmit}>
          Save
        </button>
        <button type="button" onClick={onCancel} style={buttonStyles.cancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddSubscriptionForm;
